import { useMemo } from 'react';

import { AnalyticsInstance } from './rudderStack.types';
import { getRudderStackInstance } from './rudderStack.utils';
import { useConfiguration } from '../../modules/configuration/useConfiguration';

export const useRudderStack = (): AnalyticsInstance => {
  const {
    config: {
      rudderStack: { enabled },
    },
  } = useConfiguration();

  return useMemo(() => {
    return getRudderStackInstance(enabled);
  }, [enabled]);
};
